import styled from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING._16};
  width: 100%;

  @media (max-width: 750px) {
    height: 100%;
  }

  > footer {
    display: flex;
    flex-direction: row;
    gap: ${SPACING._16};

    @media (max-width: 750px) {
      margin-top: auto;
    }
  }
`;
